import { Injectable } from '@angular/core';
import { ServiceBase } from '../shared/models/bases/serviceBase';
import { Country } from '../shared/models';
import { CountryStore } from '../stores';
import { API_ENDPOINTS } from '../shared/common/apiConstants';

@Injectable({providedIn: 'root'})
export class CountryService extends ServiceBase<Country> {
  constructor(countryStore: CountryStore) {
      super(API_ENDPOINTS.country, countryStore)
    }

}
